<!--学员分数查询-->
<template>
    <div id="queryScore" class="queryScore mt20">
        <div class="content myflex relative h-100">
            <!-- <img src="@/assets/img/cert/certQuery-bgIcon2.png" class="certQuery-bgIcon certQuery-bgIcon2 myhide" alt="certQuery-bgIcon2"> -->
            <div class="queryScoreMain flex1 maskBg">
                <div class="certForm" v-if="false">
                    <div class="title mb30">艺术教育核心素养<br/>测评报告查询</div>
                    <div class="myflex-v mb15">
                        <input
                            class="el-input__inner certForm-input"
                            placeholder="请输入姓名"
                            v-model.trim="name" />
                    </div>
                    <div class="myflex-v mb15">
                        <input
                            type="tel"
                            class="el-input__inner certForm-input"
                            placeholder="请输入身份证号"
                            v-model.trim="idCard" />
                    </div>     
                    <div>
                        <el-button class="query-btn" type="primary" :disabled='name==""||idCard==""' round size="medium" @click="query">查 询</el-button>
                    </div>                                
                </div>
                <div class="toLoginTitle">全民终身学习教育资源共享行动<br/>艺术培训机构申请加入</div>
                <el-button type="primary" class="applyBtn" @click="apply1">申 请</el-button>
            </div>
            <div class="toLoginBox flex1 maskBg">
                <div class="toLoginTitle">全民终身学习教育资源共享行动<br/>美育教师师资共享库<br/>艺术教师申请加入</div>
                <el-button type="primary" class="applyBtn" @click="apply2">申 请</el-button>
                <div class="hasLoginBox" v-if="userInfo">
                    <div :style="'background:url('+userInfo.photoPath+') center'" class="userHead" alt="login"></div>
                    <div class="ellipsis2 userName">{{userInfo.userName}}</div>
                    <div class="toLoginBtn">
                        <span class="afterLoginBtn afterLoginBtn1" @click="toCenter">管理信息</span>
                        <span class="afterLoginBtn afterLoginBtn2" @click="logout">退出登录</span>
                    </div>
                </div>
                <div class="toLoginBoxBtn pointer text-right" v-else @click="toLogin">
                    <div class="font22 mb10">美育教师登陆/注册</div>
                    <img src="@/assets/img/jiantou.png" alt="">
                </div>
                
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .pointer{cursor:pointer;}
    .queryScore{}
    .queryScoreIcon{width:140px;margin-left:20px;}
    .title{font-weight:bold;font-size:22px;line-height:1.3;color:#025A90;text-align:center;margin-bottom:10px;position:relative;}
    .code-btn{display:inline-block;width:200px;text-align:center;cursor:pointer;}
    .code-btn{position:absolute;right:0;height:40px;line-height:40px;width:100px;}
    .certForm{}
    .certForm-t{min-width:92px;display:inline-block;text-align:left;color:#fff;font-size:18px;}
    .certForm-input{width:320px;-webkit-box-shadow:0 0 4px 0px rgba(0,0,0,.1);box-shadow:0 0 20px 0px rgba(0,0,0,0.06);border-radius:0;border:none;text-align:center;
    font-size:14px;}
    .certForm-input::-webkit-input-placeholder{color:#999;}
    .code-box{position:relative;}
    .codeInput{padding-right:110px;}
    .sendCodeBtn{position:absolute;right:0px;top:1px;width:100px;text-align:center;font-size:14px;white-space:nowrap;height:38px;line-height:38px;cursor:pointer;color:#666;}
    .sendCodeBtn::before{content:'';position:absolute;left:0;top:8px;height:22px;width:1px;background:#ddd;}
    .sendCodeBtn.countDonwIng{color:#999;cursor:auto;}

    .queryScoreMain{height:300px;z-index:2;color:$theme-color;background:$theme-color;@include bg-img('../../assets/img/chaxun.png');@include bg-img('../../assets/img/img1.jpg');padding:20px;}
    .certQuery-bgIcon{position:absolute;z-index:0;}
    .certQuery-bgIcon1{top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);height:146px;z-index:-1;}
    .certQuery-bgIcon2{bottom:0;right:-8%;height:30%;}

    .query-btn{display:inline-block;height:40px;line-height:34px;padding:0 26px;text-align:center;background:#fff;border-radius:0;width:100%;
    color:#fff;cursor:pointer;@include bg-themecolor(.9);font-size:20px;text-align:center;font-weight:600;font-size:16px;}
    .query-btn:hover{background:#f4f4f4;@include bg-themecolor(1);}

    .toLoginBox{@include bg-img('../../assets/img/img2.jpg');height:300px;position:relative;padding:20px;}
    .hasLoginBox{position:absolute;right:1px;bottom:0;padding:0px;text-align:center;max-width:250px;}
    .toLoginBoxBtn{position:absolute;right:0;bottom:0;padding:30px;color:#fff;}
    .userHead{@include headphoto(62px);display:inline-block;margin-bottom:10px;}
    .toLoginBtn{cursor:pointer;text-align:center;font-size:16px;border-top-left-radius:26px;background:#154162;color:#fff;padding:5px 15px;}
    .afterLoginBtn{display:inline-block;height:100%;padding:15px 15px;}
    .toLoginArrow{height:46px;}
    .userName{font-size:20px;font-weight:600;margin-bottom:15px;color:#fff;padding: 0 10px;}
    .toLoginTitle{font-size: 23px;line-height: 1.5;font-weight: 600;opacity:1;text-align:left;color:#fff;position: relative;z-index:1;}
    .font22{font-size:22px;}
    .applyBtn{position:absolute;left:20px;bottom:20px;font-size:16px;color:#fff;}
    .applyBtn:hover{background-color:#048fe4;border-color:#048fe4;}
    .applyBtn:focus{background-color:#048fe4;border-color:#048fe4;}
    .maskBg{position:relative;}
    .maskBg::before{content:'';background:rgba(71, 56, 56, 0.1);width:100%;height:100%;left:0;top:0;position: absolute;filter:blur(1px);z-index:0;}
    @media screen and(max-width:1200px){
    }
    @media screen and(max-width:800px){
        .content{flex-wrap:wrap;display:block;}
        .certForm-input{width:290px;}
    }
</style>

<script>
import base from "@/api/base.js";
import {
		mapState,
		mapMutations
	} from 'vuex';
export default {
    name: "queryScore",
    components: {
    },
    data(){
        return {
            art: art,
            name: '',
            idCard: '',
            hasRealInfo: false,
        }
    },
    computed: mapState(["userInfo"]),
    methods: {
...mapMutations(["signOut"]),
        // getRealNameInfo(){
        //     const that = this;
        //     let params = {
        //         token: that.userInfo.token,
        //     }
        //     that.$api.pub.getRealNameInfo(params,'errorNotTips').then(res => {
        //         console.log(res,'suc');
        //         let result = res.body.realNameInfo;
        //         if (result) {
        //         that.hasRealInfo = true;
        //         }
        //         else {
        //         that.hasRealInfo = false;
        //         }
        //     }).catch(res => {
               
        //     })
            
        // },

        query(){
            let vm = this;
            if( this.name=='' ){
                vm.$message.error('请输入姓名！'); return false;
            }
            if( this.idCard=='' ){
                vm.$message.error('请输入身份证号！'); return false;
            }
            let d = {
                name: vm.name,
                idCard: vm.idCard,
            };
            vm.$api.pub.getLatestReport(d).then((res) => {
                vm.data = res.body.examineeReport;
                if(vm.data){
                    //let newurl = '/certifacate?name='+encodeURIComponent(vm.name)+'&idCard='+encodeURIComponent(vm.idCard);
                    //location.href = newurl;
                    const newurl = vm.$router.resolve({path: '/certifacate', query: {
                        name:encodeURIComponent(vm.name),
                        idCard:encodeURIComponent(vm.idCard),
                    }})
                    window.open(newurl.href,'_blank');
                }else{
                    vm.$message.error('暂未查询到证书信息');
                }
            }).catch((res) => {});
            
            return;
        },

        apply1(){
            const url = this.$router.resolve({name: 'applyClassroom'})
            window.open(url.href,'_blank')
        },
        apply2(){
            const url = this.$router.resolve({path: '/applyJoinTalentPool'})
            window.open(url.href,'_blank')
        },

        // toLogin(){
        //     this.$checkLogin.checkLogin("login");

        // },

        // getLoginInfo(){
        //     let vm = this;
        //     vm.$api.pub.getLoginInfo({token:vm.token},'errorNotTips')
        //     .then((res) => {
        //         var d = res.body.userInfo;
        //         d.userHead = d.photoPath ? art.addOssResize(d.photoPath,120) : art.addOssResize(art.defaultHeadPhoto);
        //         vm.userInfo = d;
        //     })
        //     .catch((res) => {
        //         console.log(res,'cathc');
        //         if(res.code=='902'){
        //             vm.userInfo = null;
        //             //localStorage.removeItem('userInfo');
        //             //vm.toLogin();
        //         }
        //     });
        // },
        // //去管理信息
        // toCenter(){
        //     //const newurl = vm.$router.resolve({path: base.webPersonalCenterUrl, query: {}})
        //     //window.open(newurl.href,'_blank');
        //     let that = this;
        //     console.log(that.hasRealInfo,'that.hasRealInfo');
        //     if (that.hasRealInfo){
        //         location.href = base.webPersonalCenterUrl;
        //     }
        //     else {
        //         //const newurl = that.$router.resolve({ path: '/realInfo', query: {} })
        //         //window.open(newurl.href, '_blank');
        //         location.href = base.webRealInfoUrl;
        //     }
        // },
        // //退出登录
        // logout(){
        //    this.$signOut.signOut();
        // },

        //去登录
        toLogin() {
            if(!this.userInfo.token){
                this.$checkLogin.checkLogin('login');
            }   
        },
        //去管理信息
        toCenter() {
            const that = this;
            that.$router.push({ path: "/personalCenter" });
            return;
            if (that.hasRealInfo) {
                that.$router.push({ path: "/personalCenter" });
            } else {
                that.$router.push({ path: "/realInfo" });
            }
        },
        //退出登录
        logout() {
           this.$signOut.signOut();
        },
        getLoginInfo() {
            let vm = this;
            vm.$api.mainApi
                .getLoginInfo(
                    { token: vm.userInfo.token },
                    "errorNotTips",
                    "tokenInvalidNotSkiptoLogin"
                )
                .then((res) => {
                    var d = res.body.userInfo;
                    d.userHead = d.photoPath
                        ? art.addOssResize(d.photoPath, 120)
                        : art.addOssResize(art.defaultHeadPhoto);
                    vm.userInfo = d;
                })
                .catch((res) => {
                    console.log(res, "cathc");
                    if (res.code == "902") {
                        vm.userInfo = null;
                        //localStorage.removeItem('userInfo');
                        //vm.toLogin();
                    }
                });
        },
        getRealNameInfo() {
            const that = this;
            let params = {
                token: that.userInfo.token,
            };
            that.$api.mainApi
                .getRealNameInfo(
                    params,
                    "errorNotTips",
                    "tokenInvalidNotSkiptoLogin"
                )
                .then((res) => {
                    if(res.success){
                         let result = res.body.realNameInfo;
                    if (result) {
                        that.hasRealInfo = true;
                    } else {
                        that.hasRealInfo = false;
                    }
                    }
                    else{
                        //that.$message.error(res.msg);
                    }
                   
                })
                .catch((error) => {
                    //that.$message.error(error.msg);
                });
        },

        
    },
    created(){
        //this.getRealNameInfo();
    }
}
</script>